/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export interface UserSummaryDto {
  /** User ID */
  id: string;
  /** User email */
  email?: string;
  /** First name */
  firstName?: string;
  /** Last name */
  lastName?: string;
  /** User role */
  role: string;
  /** Organization */
  organization: string;
  /** Country code */
  countryCode: string;
}
